<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" xl="2">
        <BusinessEntitiesDropDownList
          v-model="id"
          label="Business Entity Name"
          :clearable="true"
        ></BusinessEntitiesDropDownList>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" md="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import BusinessEntitiesDropDownList from './BusinessEntitiesDropDownList'

export default {
  components: {
    FilterButtons,
    FilterButtonsSmall,
    BusinessEntitiesDropDownList
  },
  computed: {
    ...mapFields('businessEntityFilters', [
      'id'
    ])
  },
  methods: {
    ...mapActions('businessEntityFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
